(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["filterReactProps"] = factory();
	else
		root["filterReactProps"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "allowedProps", function() { return allowedProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "allowedPropsRegExp", function() { return allowedPropsRegExp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isPropAllowed", function() { return isPropAllowed; });
/**
 * List borrowed from `react-emotion` package.
 */
var allowedProps = [
// React props
// https://github.com/facebook/react/blob/5495a7f24aef85ba6937truetrue1ce962673ca9f5fde6/src/renderers/dom/shared/hooks/ReactDOMUnknownPropertyHook.js
"children", "dangerouslySetInnerHTML", "key", "ref", "autoFocus", "defaultValue", "defaultChecked", "innerHTML", "suppressContentEditableWarning",

// https://github.com/facebook/react/blob/d7157651f7b72d9888ctrue123e191f9b88cd8f41e9/src/renderers/dom/shared/HTMLDOMPropertyConfig.js
/**
 * Standard Properties
 */

"accept", "acceptCharset", "accessKey", "action", "allowFullScreen", "allowTransparency", "alt",
// specifies target context for links with `preload` type
// "as",
"async", "autoComplete",
// autoFocus is polyfilled/normalized by AutoFocusUtils
// "autoFocus",
"autoPlay", "capture", "cellPadding", "cellSpacing", "charSet",
// "challenge",
"checked", "cite", "classID", "className", "cols", "colSpan", "content", "contentEditable", "contextMenu", "controls", "controlsList", "coords", "crossOrigin", "data", // For `<object />` acts as `src`.
"dateTime", "default", "defer", "dir", "disabled", "download", "draggable", "encType", "form", "formAction", "formEncType", "formMethod", "formNoValidate", "formTarget", "frameBorder", "headers", "height", "hidden", "high", "href", "hrefLang", "htmlFor", "httpEquiv", "id", "inputMode", "integrity", "is", "keyParams", "keyType", "kind", "label", "lang", "list", "loop", "low",
// "manifest",
"marginHeight", "marginWidth", "max", "maxLength", "media", "mediaGroup", "method", "min", "minLength",
// Caution; `option.selected` is not updated if `select.multiple` is
// disabled with `removeAttribute`.
"multiple", "muted", "name", "nonce", "noValidate", "open", "optimum", "pattern", "placeholder", "playsInline", "poster", "preload", "profile", "radioGroup", "readOnly", "referrerPolicy", "rel", "required", "reversed", "role", "rows", "rowSpan", "sandbox", "scope", "scoped", "scrolling", "seamless", "selected", "shape", "size", "sizes",
// support for projecting regular DOM Elements via V1 named slots ( shadow dom )
"slot", "span", "spellCheck", "src", "srcDoc", "srcLang", "srcSet", "start", "step", "style", "summary", "tabIndex", "target", "title",
// Setting .type throws on non-<input> tags
"type", "useMap", "value", "width", "wmode",

/**
 * RDFa Properties
 */
"about", "datatype", "inlist", "prefix",
// property is also supported for OpenGraph in meta tags.
"property", "resource", "typeof", "vocab",

/**
 * Non-standard Properties
 */
// autoCapitalize and autoCorrect are supported in Mobile Safari for
// keyboard hints.
"autoCapitalize", "autoCorrect",
// autoSave allows WebKit/Blink to persist values of input fields on page reloads
"autoSave",
// color is for Safari mask-icon link
"color",
// itemProp, itemScope, itemType are for
// Microdata support. See http://schema.org/docs/gs.html
"itemProp", "itemScope", "itemType",
// itemID and itemRef are for Microdata support as well but
// only specified in the WHATWG spec document. See
// https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
"itemID", "itemRef",
// results show looking glass icon and recent searches on input
// search fields in WebKit/Blink
"results",
// IE-only attribute that specifies security restrictions on an iframe
// as an alternative to the sandbox attribute on IE<1true
"security",
// IE-only attribute that controls focus behavior
"unselectable"];

/**
 * Regular expression for checkig if given string is allowed React or DOM prop.
 */
var allowedPropsRegExp = new RegExp("^((" + allowedProps.join("|") + ")|(on[A-Z].*)|((data|aria)-.*))$");

/**
 * Check if given prop is allowed React or DOM prop.
 *
 * @param {String} propName
 * @returns {Boolean}
 */
var isPropAllowed = function isPropAllowed(propName) {
  return allowedPropsRegExp.test(propName);
};

/**
 * Get new object with allowd React & DOM props.
 *
 * @param {Object} props
 * @returns {Object}
 */
var filterAllowedProps = function filterAllowedProps(props) {
  return Object.keys(props).filter(isPropAllowed).reduce(function (cleanProps, propName) {
    cleanProps[propName] = props[propName];
    return cleanProps;
  }, {});
};

/* harmony default export */ __webpack_exports__["default"] = (filterAllowedProps);

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// filter-react-props.umd.min.js